import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Box, Typography } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const DashboardGraph = ({ dataGraph }) => {
  // Extract counts for students and teachers based on gender
  const girlCount = dataGraph.students.filter(student => student.gender === 'Female').length;
  const boyCount = dataGraph.students.filter(student => student.gender === 'Male').length;

  const maleTeacherCount = dataGraph.teachers.filter(teacher => teacher.gender === 'Male').length;
  const femaleTeacherCount = dataGraph.teachers.filter(teacher => teacher.gender === 'Female').length;

  // Data structure for the chart
  const data = {
    labels: ['Female student', 'Male Student', 'Male Teachers', 'Female Teachers'],
    datasets: [
      {
        label: 'Count',
        data: [girlCount, boyCount, maleTeacherCount, femaleTeacherCount],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
        borderColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0'],
        borderWidth: 1,
      },
    ],
  };

  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Student and Teachers',
      },
    },
  };

  return (
    <Box sx={{ width: '80%', mx: 'auto', mt: 5 }}>
      <Typography variant="h4" gutterBottom>
       Demographics of Students and Educators
      </Typography>
      <Bar data={data} options={options} />
    </Box>
  );
};

export default DashboardGraph;
